import {useState} from "react";
import {API_SHARE_MARKETPLACE_RIGHTS_SELL_SHARES} from "../common/api/apiConstants";
import {shareMarketplaceAPI} from "../common/api/shareMarketplaceAPI";
import {createURLQueryFromParams} from "../common/api/apiUtil";

export const useRightsSellShares = () => {


    const [rightsSellShares, setRightsSellShares] = useState({});
    const [loadingSellShares, setLoadingSellShares] = useState(false);
    const [errorSellShares, setErrorSellShares] = useState(null);

    const getRightsSellShares = (hapimag_member_id) => {
        setLoadingSellShares(true);
        setErrorSellShares(null);

        const params = {};
        if (hapimag_member_id) {
            params.hapimag_member_id = hapimag_member_id;
        }

        shareMarketplaceAPI.get(API_SHARE_MARKETPLACE_RIGHTS_SELL_SHARES + createURLQueryFromParams(params), {redirectOnError: false})
            .then(res => res.data)
            .then(response => {
                setLoadingSellShares(false);
                response && setRightsSellShares(response);
            })
            .catch(err => {
                setLoadingSellShares(false);
                setErrorSellShares(err);
            });

    };

    return {
        rightsSellShares,
        getRightsSellShares,
        loadingSellShares,
        errorSellShares
    };
};
